export const setItem = (key, value) => {
	try {
		const serialized = JSON.stringify(value);
		sessionStorage.setItem(key, serialized);
	} catch (err) {
		console && console.error(`Something went wrong: ${err}`);
	}
};

export const getItem = (key) => {
	try {
		const serialized = sessionStorage.getItem(key);
		if (serialized === null) {
			return undefined;
		}
		return JSON.parse(serialized);
	} catch (err) {
		return undefined;
	}
};



// WEBPACK FOOTER //
// ../source/common/helpers/session-storage.js